/**
 * @generated SignedSource<<14cd8f49c961e54ea447f7e9004435fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveBwaMonthInput = {
  id: string;
};
export type DeleteBwaMonthDialogMutation$variables = {
  input: RemoveBwaMonthInput;
};
export type DeleteBwaMonthDialogMutation$data = {
  readonly removeBwaMonth: {
    readonly id: string;
  };
};
export type DeleteBwaMonthDialogMutation = {
  response: DeleteBwaMonthDialogMutation$data;
  variables: DeleteBwaMonthDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "removeBwaMonth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteBwaMonthDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteBwaMonthDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "adb2c1fe0d59e1ef47b21ae316e65f34",
    "id": null,
    "metadata": {},
    "name": "DeleteBwaMonthDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteBwaMonthDialogMutation(\n  $input: RemoveBwaMonthInput!\n) {\n  removeBwaMonth(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb5b43a8d6239943659f086f29d6f644";

export default node;
